const MuftiUserList = (state = [], action) => {
    switch (action.type) {
        case 'AdminMuftiGetList_SUCCESS':
            return action.payload.res.data
        default:
            return state
    }
}
export default MuftiUserList